'use es6';

import styled from 'styled-components';
import { OBSIDIAN, OLAF, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import UIMultiLevelDropdown from 'UIComponents/dropdown/UIMultiLevelDropdown';
export default styled(UIMultiLevelDropdown).withConfig({
  displayName: "StyleProtectedUIMultiLevelDropdown",
  componentId: "sc-1748fn0-0"
})(["display:block !important;& button{color:", " !important;background-color:", " !important;&:hover{background-color:", " !important;}}"], OBSIDIAN, OLAF, CALYPSO_LIGHT);